export const FloorSizeIcon = () => (
  <svg viewBox="0 0 460 460" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32px">
    <g>
      <path d="M20.54 83.21V20.45h418.92v418.93h-60.2M20.54 118.5l321.05 321.05-321.05-.17V118.5z" />
      <path d="m74.87 246.73 135.49 135.49-135.49-.07V246.73zM77.92 129.98h45.12M177.91 129.98h62.9M240.81 20.45v143.44M240.81 206.44v82.42M351.79 20.45V103M351.79 160.36v86.37M439.46 246.73H317.88M271.02 246.73h-30.21M65.72 417.83v21.55M132.92 417.83v21.55M203.82 417.83v21.55M271.02 417.83v21.55" />
    </g>
  </svg>
);
